import React, { FunctionComponent, createContext, useContext } from 'react';

export type TSchemaItem = {
  name: string;
  type: string;
  format?: string;
  description: string;
  required?: boolean;
  readOnly?: boolean;
  writeOnly?: boolean;
  immutable?: boolean;
  isMap?: boolean;
  refName?: string;
  groupType?: string;
  values?: (string | number)[];
  refObject?: TSchema | null;
};

export type TSchema = {
  name: string;
  description: string;
  oneOf: Record<string, string[]>;
  properties: TSchemaItem[];
};

type SchemasProviderProps = {
  schemas: Record<string, TSchema>;
};

export type SchemasProviderType = SchemasProviderProps;

const SchemasProviderContext = createContext<SchemasProviderType>({
  schemas: {},
});
SchemasProviderContext.displayName = 'Schema';

export function useSchemas() {
  return useContext(SchemasProviderContext);
}

const SchemasProvider: FunctionComponent<React.PropsWithChildren<SchemasProviderProps>> = ({
  schemas,
  children,
}) => {
  return (
    <SchemasProviderContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        schemas,
      }}>
      {children}
    </SchemasProviderContext.Provider>
  );
};

export default SchemasProvider;
